/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';

import { AlertService } from '@typescript-kit/core';

import { TagInfo } from '@teamworks/global';
import { TimeClockService } from './time-clock.service';

@Injectable()
export class TagInfoResolverService implements Resolve<TagInfo> {

  constructor(
    private readonly router: Router,
    private readonly alertService: AlertService,
    private readonly timeClockService: TimeClockService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<TagInfo> {
    const timeClockId = route.root.firstChild.paramMap.get('id');
    return null;
    // TODO MJ: FIX OR DELETE (NfcKeyInfo -> TagInfo)
    // const nfcKey = route.paramMap.get('nfc-key');
    // return this.timeClockService.loadTagInfo(nfcKey)
    //   .then((tagInfoData: TagInfoData) => {
    //     if (tagInfoData.token) {
    //       return this.router.navigate(['/time-clock', timeClockId, 'register', tagInfoData.token])
    //         .then(() => null);
    //     }
    //     return new TagInfo(tagInfoData);
    //   })
    //   .catch((error: any) => {
    //     return this.router.navigate(['/time-clock', timeClockId, 'idle'])
    //       .then(() => {
    //         this.alertService.alertError(error, 10000);
    //         return null;
    //       });
    //
    //   });
  }

}
